import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactDetailsComponent } from './contact-details.component';
import { RouterModule } from '@angular/router';
import { contactDetailsRoutes } from './contact-details.routes';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from '../shared/layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { ContactDetailsService } from './contact-details.service';
import { NumberDetailsComponent } from './number-details/number-details.component';
import { ContactNoteComponent } from './contact-note/contact-note.component';
import { ImportDetailsComponent } from './import-details/import-details.component';
import { FormsModule } from '@angular/forms';
import { ContactHistoryComponent } from './contact-history/contact-history.component';
import { RecordHistoryTypeComponent } from './contact-history/record-history-type/record-history-type.component';
import { ContactHistoryModule } from './contact-history/contact-history.module';
import { ContactsModule } from '../contacts/contacts.module';
import { ContactTagsComponent } from './contact-tags/contact-tags.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(contactDetailsRoutes),
    TranslateModule,
    LayoutModule,
    SharedModule,
    FormsModule,
    ContactHistoryModule,
    ContactsModule,
    NgxPermissionsModule,
    MatMenuModule
  ],
  providers: [ContactDetailsService],
  declarations: [
    ContactDetailsComponent,
    NumberDetailsComponent,
    ContactNoteComponent,
    ImportDetailsComponent,
    ContactHistoryComponent,
    RecordHistoryTypeComponent,
    ContactTagsComponent
  ]
})
export class ContactDetailsModule {}
